'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

var _telephone = require('./src/telephone');

var _telephone2 = _interopRequireDefault(_telephone);

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _util = require('./src/util');

var _util2 = require('../util');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportArmsError = function reportArmsError(logName, error, member) {
    var errorStr = JSON.stringify(error);
    _zoroArms2.default.error(logName + ' ' + errorStr + ' ' + member);
};

// 覆盖语言包
if (window.I18N && window.I18N.xman) {
    Object.assign(_i18n2.default, window.I18N.xman);
}

var Join = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Join, _React$Component);

    function Join(props) {
        (0, _classCallCheck3.default)(this, Join);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Join.__proto__ || Object.getPrototypeOf(Join)).call(this, props));

        _this.region = _zoroCookie2.default.getRegion();
        _this.isChina = _this.region === 'CN';
        _this.lastCheckedEmail = null;
        _this.nCf = null;
        _this.nc = null;
        _this.ncChecked = true;
        _this.slideBoxId = 'ws-xman-register-slide-box';
        _this.actionUrl = 'https://login.aliexpress.com/join/buyer/noMemberResult.htm';

        _this.onRegister = function (event) {
            // 检查密码，邮箱，安全
            var passwordCheck = _this.onPasswordBlur();
            var emailCheck = _this.onEmailBlur();
            _this.onNcChecked();

            // 注册部分前端校验均已经通过
            if (passwordCheck && emailCheck) {
                // 交给上层组件处理loading状态
                _this.props.toggleMask(true);
                // 拼接url参数
                var postParams = {
                    action: _this.props.registerAction,
                    from: _this.props.registerFrom,
                    registerFrom: _this.props.registerFrom,
                    cc: _this.props.couponCode,
                    event_submit_do_buyer_register: 'anything',
                    email: _this.state.emailValue,
                    password: _this.state.passwordValue,
                    t: Math.random(),
                    allowEDM: _this.state.allowEDM,
                    _csi_: _this.props.sessionId
                };
                _this.setState({
                    beginSendPostTime: new Date()
                });
                console.log('beginSendPostTime', _this.state.beginSendPostTime);
                // 发送注册请求
                (0, _util.sendPost)(_this.actionUrl, postParams, _this.ncData, _this.nCf, _this.state.emailValue).then(function (returnObj) {
                    _this.props.toggleMask(false);
                    if (typeof returnObj === 'undefined') {
                        _this.props.toggleMask(false);
                        _this.setState({
                            showEmailTip: true,
                            emailTip: _i18n2.default.UNAVIALABLE_SERVICE,
                            emailError: 'input-error'
                        });
                        reportArmsError(_this.actionUrl, _util2.errorKey.sendPostReturnUndefined, _this.state.emailValue);
                        return;
                    }

                    if (returnObj.result === 'true') {
                        _this.freeLogin(returnObj, _this.state.emailValue, 'mail');
                    } else {
                        _this.props.toggleMask(false);
                        // 处理服务器返回错误信息
                        var code = returnObj.errorCode;
                        if (returnObj.email) {
                            // 当服务端返回错误信息为email出错并且错误码为114时，证明注册邮箱已存在，引导登陆页
                            if (returnObj.errorCode && code === 114) {
                                _this.setState({
                                    showEmailTip: true,
                                    emailExistTip: returnObj.email,
                                    emailError: 'input-error'
                                });
                            } else {
                                _this.setState({
                                    showEmailTip: true,
                                    emailTip: returnObj.email,
                                    emailError: 'input-error'
                                });
                            }
                        }
                        if (returnObj.password) {
                            _this.setState({
                                showPasswordTip: true,
                                passwordTip: returnObj.password,
                                passwordError: 'input-error'
                            });
                        }

                        if (returnObj.checkCode) {
                            // 针对滑动校验出错，展示error
                            _this.setState({
                                showPasswordTip: true,
                                passwordTip: returnObj.checkCode
                            });
                            reportArmsError(_this.actionUrl, returnObj.checkCode, _this.state.emailValue);
                        } else if (code) {
                            // 针对其他情况出错 上报出错日志
                            reportArmsError(_this.actionUrl, code, _this.state.emailValue);
                        }

                        if (code === 114 || code === 115) {
                            // 注册校验email已存在
                            (0, _util2.clickDot)({
                                buttonType: 'register_Email_exists_back',
                                objectType: 'input_box'
                            });
                        } else if (code === 102 || code === 110 || code === 111 || code === 112 || code === 113 || code === 116) {
                            // 注册校验email格式错误
                            (0, _util2.clickDot)({
                                buttonType: 'register_email_format_error_back',
                                objectType: 'input_box'
                            });
                        } else if (code === 150 || code === 151 || code === 152 || code === 153) {
                            // 注册校验密码格式错误
                            (0, _util2.clickDot)({
                                buttonType: 'register_password_format_error_back',
                                objectType: 'input_box'
                            });
                        } else {
                            // 注册其他错误
                            (0, _util2.clickDot)({
                                buttonType: 'register_fail_others',
                                objectType: 'input_box',
                                objectValue: returnObj
                            });
                        }

                        if ((0, _util.isMobile)()) {
                            _this.nc && _this.nc.reset();
                        } else {
                            _this.nc && _this.nc.reload();
                        }
                        _this.ncChecked = false;
                    }
                });
            }

            // 注册账号点击打点
            (0, _util2.clickDot)({
                objectType: 'button',
                buttonType: 'register_create_account',
                objectValue: 'register_create_account'
            });

            event.preventDefault();
            event.stopPropagation();
        };

        _this.onEmailChange = function (event) {
            var emailValue = event.target.value;
            _this.setState({
                emailValue: event.target.value
            });

            // 发现最后一个字符为@，开启弹框
            if (/^[^@]*@[^@]*$/.test(emailValue) && emailValue.charAt(emailValue.length - 1) === '@') {
                _this.setState({
                    showEmailPrompt: true
                });
            } else {
                _this.setState({
                    showEmailPrompt: false
                });
            }
        };

        _this.onEmailBlur = function (preCheck) {
            var emailValue = _this.state.emailValue;

            if (!emailValue) return;
            if ((0, _util.checkEmail)(emailValue)) {
                // 隐藏提示，开启loading
                _this.setState({
                    showEmailTip: false,
                    emailError: ''
                });

                // 最后一次检查的email
                _this.laskCheckEmail = emailValue;

                // 发送请求先检查一次
                // 失焦会做这样一次检查，直接点击注册不会
                if (preCheck) {
                    _this.setState({
                        showEmailChecking: true
                    });
                    (0, _zoroRequest2.default)({
                        url: 'https://login.aliexpress.com/join/preCheckForRegister.htm',
                        dataType: 'json',
                        data: {
                            registerFrom: _this.props.registerFrom,
                            umidToken: _this.nCf ? _this.nCf.getUmidToken() : '',
                            ua: _this.nCf ? _this.nCf.getUA() : '',
                            email: emailValue
                        },
                        withCredentials: true // 支持附带详细信息
                    }).then(function (data) {
                        _this.setState({
                            showEmailChecking: false
                        });

                        if (data.isDisplayCheckCode) {
                            // 后端校验账号通过
                            _this.setState({
                                showRegisterSlide: true
                            });
                            _this.initNoCaptcha(_i18n2.default, data);
                            _this.ncChecked = false;
                            // 输入邮箱完成后打点
                            (0, _util2.clickDot)({
                                objectType: 'input_box',
                                buttonType: 'register_account',
                                objectValue: emailValue
                            });
                        } else {
                            _this.setState({
                                showRegisterSlide: false
                            });
                            _this.ncChecked = true;
                            // 异步校验email格式错误打点
                            (0, _util2.clickDot)({
                                buttonType: 'register_email_format_error_asynchronous',
                                objectType: 'input_box'
                            });
                        }

                        if (!data.isEmailExisted) {
                            // 如果邮箱可用，关闭提示
                            _this.setState({
                                showEmailTip: false,
                                emailError: ''
                            });
                        } else {
                            // 如果邮箱已经被注册，显示提示
                            _this.setState({
                                showEmailTip: true,
                                emailExistTip: _i18n2.default.EMAIL_EXISTS
                            });
                        }
                    }).catch(function () {
                        // 关闭检查loading，显示错误信息
                        _this.setState({
                            showEmailChecking: false,
                            showEmailTip: false,
                            emailError: 'input-error',
                            emailExistTip: _i18n2.default.UNAVIALABLE_SERVICE
                        });
                    });
                }
                return true;
            } else {
                _this.setState({
                    showEmailTip: true,
                    emailTip: _i18n2.default.INVALID_EMAIL,
                    emailError: 'input-error'
                });

                return false;
            }
        };

        _this.onPasswordChange = function (event) {
            _this.setState({
                passwordValue: event.target.value
            });
        };

        _this.onPasswordBlur = function () {
            if ((0, _util.checkPassword)(_this.state.passwordValue)) {
                // 关闭错误提示
                _this.setState({
                    showPasswordTip: false,
                    passwordError: ''
                });
                // 输入密码完成后打点
                (0, _util2.clickDot)({
                    objectType: 'input_box',
                    buttonType: 'register_password',
                    objectValue: _this.state.passwordValue
                });

                return true;
            } else {
                // 显示错误提示
                _this.setState({
                    showPasswordTip: true,
                    passwordTip: _i18n2.default.INVALID_PASSWORD,
                    passwordError: 'input-error'
                });

                return false;
            }
        };

        _this.togglePassword = function () {
            _this.setState(function (state) {
                return {
                    showPassword: !state.showPassword
                };
            });
        };

        _this.onGuideSignIn = function () {
            // 把这个点击Sign In的事件抛到父级组件
            // 这个抛出去的参数是最后一次经过检查的email参数
            _this.props.mailSignIn(_this.laskCheckEmail);
            // 注册失败引导至登陆页打点
            (0, _util2.clickDot)({
                buttonType: 'register_fail_signin',
                objectType: 'button'
            });
        };

        _this.onEmailPrompt = function (value) {
            _this.setState(function (state) {
                return {
                    emailValue: state.emailValue + value,
                    showEmailPrompt: false
                };
            });

            // 为什么要这样才能focus呢
            setTimeout(function () {
                _this.emailNode.focus();
            }, 0);
        };

        _this.onNcChecked = function () {
            if (_this.ncChecked) {
                _this.setState({
                    showRegisterSlideTip: false
                });
            } else {
                _this.setState({
                    showRegisterSlideTip: true,
                    registerSlideTip: _i18n2.default.SLIDE_SUBMIT_ERROR_TIPS
                });
            }

            return _this.ncChecked;
        };

        _this.onArgeementClick = function () {
            (0, _util2.clickDot)({
                objectType: 'button',
                buttonType: 'register_agreement',
                objectValue: 'register_agreement'
            });
        };

        _this.showEmail = function () {
            _this.setState({
                showEmailContent: true,
                showSmsContent: false,
                isShowViaSMS: true,
                isShowViaEmail: false,
                isShowAgreement: true
            });
        };

        _this.showSms = function () {
            _this.setState({
                showEmailContent: false,
                showSmsContent: true,
                isShowViaSMS: false,
                isShowViaEmail: true
            });
        };

        _this.noPhoneRegion = function () {
            _this.setState({
                showEmailContent: true,
                showSmsContent: false,
                isShowViaSMS: false,
                isShowViaEmail: false
            });
        };

        _this.renderTelphone = function () {
            return _this.state.showSmsContent ? _react2.default.createElement(_telephone2.default, {
                countryCodeClassName: _this.countryCodeClassName,
                countryCode: _this.countryCode,
                registerFrom: _this.props.registerFrom,
                nCf: _this.nCf,
                mailSignIn: _this.props.mailSignIn,
                showEmail: _this.showEmail,
                showViaEmail: _this.showViaEmail,
                actionUrl: _this.actionUrl,
                toggleMask: _this.props.toggleMask,
                freeLogin: _this.freeLogin,
                sessionId: _this.props.sessionId,
                batmanNav: _this.props.batmanNav,
                showAgreement: _this.showAgreement,
                showSNS: _this.props.showSNS,
                getBeginSendPostTime: _this.getBeginSendPostTime,
                isShowEDM: _this.state.isShowEDM,
                allowEDM: _this.state.allowEDM,
                textEDM: _this.state.textEDM,
                handleChangeEDM: function handleChangeEDM(params) {
                    _this.edmCheckChange(params);
                }
            }) : null;
        };

        _this.renderMail = function () {
            var togglePasswordClass = (0, _classnames2.default)('toggle-password', {
                'password-show': _this.state.showPassword,
                'password-hide': !_this.state.showPassword
            });
            return _this.state.showEmailContent ? _react2.default.createElement(
                'div',
                { className: 'batman-join' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-box' },
                    _react2.default.createElement('input', { className: 'email ' + _this.state.emailError, ref: function ref(node) {
                            _this.emailNode = node;
                        }, value: _this.state.emailValue, onChange: _this.onEmailChange, onBlur: _this.onEmailBlur.bind(null, true), placeholder: _i18n2.default.EMAIL }),
                    _this.state.showEmailChecking ? _react2.default.createElement('img', { className: 'email-checking', src: '//u.alicdn.com/wimg/buyer/single/loading_1.gif', width: '16', height: '16', alt: 'loading' }) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'error-tip', style: { display: _this.state.showEmailTip ? 'block' : 'none' } },
                        _this.state.emailExistTip ? _react2.default.createElement(
                            'div',
                            null,
                            _this.state.emailExistTip,
                            '\xA0\xA0',
                            _react2.default.createElement(
                                'a',
                                { className: 'email-signin', onClick: _this.onGuideSignIn },
                                _i18n2.default.SIGN_IN + ' >',
                                ' '
                            )
                        ) : _this.state.emailTip
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'email-prompt', style: { display: _this.state.showEmailPrompt ? 'block' : 'none' } },
                        _react2.default.createElement(
                            'ul',
                            { className: 'email-prompt-ul' },
                            _this.state.joinData && _this.state.joinData.popularEmailSuffixes.map(function (e) {
                                return _react2.default.createElement(
                                    'li',
                                    { key: e, onMouseDown: function onMouseDown() {
                                            return _this.onEmailPrompt(e);
                                        } },
                                    e
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'input-box' },
                    _react2.default.createElement('input', {
                        className: 'password ' + _this.state.passwordError,
                        type: _this.state.showPassword ? 'text' : 'password',
                        value: _this.state.password,
                        onChange: _this.onPasswordChange,
                        onBlur: _this.onPasswordBlur,
                        placeholder: _i18n2.default.PASSWORD
                    }),
                    _react2.default.createElement('span', { className: togglePasswordClass, onClick: _this.togglePassword }),
                    _this.state.showPasswordTip ? _react2.default.createElement(
                        'div',
                        { className: 'error-tip' },
                        _this.state.passwordTip
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'input-box', style: { display: _this.state.showRegisterSlide ? 'block' : 'none' } },
                    _react2.default.createElement('div', { className: 'register-slide-box', id: _this.slideBoxId }),
                    _this.state.showRegisterSlideTip ? _react2.default.createElement(
                        'div',
                        { className: 'error-tip' },
                        _this.state.registerSlideTip
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'edm-box' },
                    _this.state.isShowEDM ? _react2.default.createElement('input', { checked: _this.state.allowEDM, onChange: function onChange(param) {
                            _this.edmCheckChange(param);
                        }, type: 'checkbox', id: 'register-edm', name: 'edm-checkbox' }) : '',
                    _this.state.isShowEDM ? _react2.default.createElement(
                        'span',
                        null,
                        _this.state.textEDM
                    ) : ''
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-box' },
                    _react2.default.createElement(
                        'a',
                        { className: 'submit', onClick: _this.onRegister },
                        _i18n2.default.CREATE_MY_ACCOUNT
                    )
                )
            ) : null;
        };

        _this.state = {
            joinData: null, // 接口请求来的email数据
            emailValue: '', // email输入框
            showEmailTip: false, // 显示email错误提示
            emailTip: '', // email错误提示
            emailExistTip: false, // email已经存在提示
            showEmailChecking: false, // 显示email检查loading
            showEmailPrompt: false, // 显示email弹出框

            passwordValue: '', // 密码框
            showPassword: false, // 显示密码
            showPasswordTip: false, // 显示密码错误提示
            passwordTip: '', // 密码错误提示

            showRegisterSlide: false, // 显示注册滑块校验
            showRegisterSlideTip: false, // 显示注册滑块提示
            registerSlideTip: '', // 注册滑块提示

            showEmailContent: true, // 展示切换email
            showSmsContent: false, // 展示切换sms

            isShowViaEmail: true, // 展示切换email注册提示
            isShowViaSMS: false, // 展示切换
            isShowAgreement: true, // 是否展示协议

            emailError: '', // email校验错误类名
            passwordError: '', // 密码校验错误类名

            isShowEDM: false, // 默认不展示订阅通知
            allowEDM: false, // 默认不发送订阅通知
            textEDM: '', // 订阅提示


            beginSendPostTime: null // 开始发送注册请求时间


        };
        _this.showEmail = _this.showEmail.bind(_this);
        _this.showSms = _this.showSms.bind(_this);
        _this.showViaEmail = _this.showViaEmail.bind(_this);
        _this.freeLogin = _this.freeLogin.bind(_this);
        _this.showAgreement = _this.showAgreement.bind(_this);
        _this.getBeginSendPostTime = _this.getBeginSendPostTime.bind(_this);
        return _this;
    }

    // 获取当前地区


    // 是否是中国用户


    // 最后一次验证的email


    // 安全


    // 滑块对象


    // 滑块检测状态(默认是true)
    // eslint-disable-line

    (0, _createClass3.default)(Join, [{
        key: 'componentDidMount',
        // 提交注册路径

        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                showPhoneRegister = _props.showPhoneRegister,
                isRegisterPhone = _props.isRegisterPhone;

            this.showSwitchJoin(showPhoneRegister, isRegisterPhone);
            // 是否订阅edm
            var clientType = (0, _util.isMobile)() ? 'msite' : 'pc';
            (0, _util2.getEDMRequest)(clientType).then(function (resJson) {
                if (resJson.data) {
                    var _resJson$data = resJson.data,
                        regEnabled = _resJson$data.regEnabled,
                        copywrites = _resJson$data.copywrites;

                    var regCheckBoxTxt = !!(copywrites && copywrites.regCheckBoxTxt);
                    _this2.setState({
                        isShowEDM: regEnabled && regCheckBoxTxt,
                        textEDM: regCheckBoxTxt ? copywrites.regCheckBoxTxt : ''
                    });
                }
            }, function (error) {
                _zoroArms2.default.error(error);
            });
            // 获取token，保存到属性
            this.setUmidToken();
            // 引入安全产品，只引用一遍
            (0, _util.introduceNoCaptcha)();

            // 初始化事件
            this.props.afterJoinInit();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props2 = this.props,
                showPhoneRegister = _props2.showPhoneRegister,
                isRegisterPhone = _props2.isRegisterPhone;

            if (this.props.joinUiConfig !== nextProps.joinUiConfig) {
                // 获取join数据，更新状态
                this.setJoinData(nextProps.joinUiConfig);
            }
            if (showPhoneRegister !== nextProps.showPhoneRegister || isRegisterPhone !== nextProps.isRegisterPhone) {
                this.showSwitchJoin(nextProps.showPhoneRegister, nextProps.isRegisterPhone);
            }
        }
    }, {
        key: 'showSwitchJoin',
        value: function showSwitchJoin(showPhoneRegister, isRegisterPhone) {
            if (!showPhoneRegister) {
                this.noPhoneRegion(); // 不展示手机注册
            } else if (showPhoneRegister && !isRegisterPhone) {
                this.showEmail();
            } else if (showPhoneRegister && isRegisterPhone) {
                this.showSms();
            }
        }
    }, {
        key: 'getBeginSendPostTime',
        value: function getBeginSendPostTime(date) {
            this.setState({
                beginSendPostTime: date
            });
        }
    }, {
        key: 'freeLogin',
        value: function freeLogin(returnObj, member, registerType) {
            var _this3 = this;

            // 免登接口,返回数组newLoginUrlList，会是一个或两个，并行请求，用来setcookie,无返回值
            // https://yuque.antfin-inc.com/wb-zxt333788/ngqzc9/opeuxn errorCode错误码
            var isArray = Array.isArray(returnObj.newLoginUrlList);
            if (isArray && returnObj.newLoginUrlList) {
                Promise.all(returnObj.newLoginUrlList.map(function (newLoginUrl) {
                    return (0, _zoroRequest2.default)({
                        url: newLoginUrl,
                        type: 'GET',
                        timeout: 10000,
                        withCredentials: true // 支持附带详细信息
                    });
                })).then(function () {
                    if (_zoroCookie2.default.isLoggedIn()) {
                        if (_this3.state.joinData.sendCouponConfig.needSendCoupon && _this3.props.isSendCoupon) {
                            _this3.props.afterWithCouponJoin();
                            setTimeout(function () {
                                _this3.getCoupon(member);
                            }, _this3.state.joinData.sendCouponConfig.sendCouponTimeWait);
                            if (registerType === 'mail') {
                                (0, _util2.clickDot)({
                                    pageType: 'buyer_join',
                                    buttonType: 'batman_email_join_success'
                                });
                            }
                            if (registerType === 'phone') {
                                (0, _util2.clickDot)({
                                    pageType: 'buyer_join',
                                    buttonType: 'batman_phone_join_success'
                                });
                            }
                        } else {
                            _this3.props.toggleMask(false);
                            _this3.props.afterJoin(registerType);
                        }
                    }
                }).catch(function (err) {
                    _this3.props.toggleMask(false);
                    reportArmsError(returnObj.newLoginUrlList, err, member);
                    // 免登失败打点
                    (0, _util2.clickDot)({
                        buttonType: 'register_auto_signin_fail',
                        objectType: 'input_box'
                    });
                });
            } else {
                reportArmsError(this.actionUrl, _util2.errorKey.nologinList);
            }
        }

        // 注册


        // email change


        // email 失焦
        // 当在输入emial时，直接点击注册，会导致该方法触发两个，但是情况很少，忽略


        // 受控组件改变value值


        // password 失焦


        // 隐藏和显示密码框


        // 注册失败引导至登录页


        // email弹出框点击事件


        // 安全监测


        // 点击注册协议和政策打点


        // 展示email框


        // 展示sms


        // 不支持手机注册区域

    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setRegionInfo();
        }

        // 设置国家信息

    }, {
        key: 'setRegionInfo',
        value: function setRegionInfo() {
            if (this.region === 'RU') {
                this.countryCodeClassName = 'ru';
                this.countryCode = '+7';
            } else if (this.region === 'SA') {
                this.countryCodeClassName = 'sa';
                this.countryCode = '+966';
            } else if (this.region === 'AE') {
                this.countryCodeClassName = 'ae';
                this.countryCode = '+971';
            } else if (this.region === 'ES') {
                this.countryCodeClassName = 'es';
                this.countryCode = '+34';
            }
        }
    }, {
        key: 'showViaEmail',
        value: function showViaEmail(boolean) {
            this.setState({
                isShowViaEmail: boolean
            });
        }
    }, {
        key: 'showAgreement',
        value: function showAgreement(boolean) {
            this.setState({
                isShowAgreement: boolean
            });
        }
    }, {
        key: 'edmCheckChange',
        value: function edmCheckChange() {
            var value = this.state.allowEDM;
            this.setState({
                allowEDM: !value
            });
        }
    }, {
        key: 'renderRegisterTips',


        // 优惠券的渲染逻辑
        value: function renderRegisterTips() {
            var _props3 = this.props,
                isSendOtherCoupon = _props3.isSendOtherCoupon,
                otherBenefits = _props3.otherBenefits;

            var result = null;
            if (isSendOtherCoupon && otherBenefits) {
                result = _react2.default.createElement(
                    'div',
                    { className: 'register-tips register-benefits-tips' },
                    _react2.default.createElement('span', { className: 'currency', style: { background: "url('" + otherBenefits.content.iconUrl + "') no-repeat", backgroundSize: 'contain' } }),
                    _react2.default.createElement(
                        'span',
                        { className: 'register-desc' },
                        otherBenefits.content.title
                    )
                );
            } else if (this.props.isSendCoupon && this.state.joinData && this.state.joinData.sendCouponConfig.needSendCoupon) {
                result = _react2.default.createElement(
                    'div',
                    { className: 'register-tips' },
                    _react2.default.createElement('span', { className: 'currency' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'register-desc' },
                        this.state.joinData.sendCouponConfig.sendCouponTip
                    )
                );
            }

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'join-wrap', style: { display: this.props.joinUiConfig || false ? 'block' : 'none' } },
                this.isChina ? _react2.default.createElement(
                    'div',
                    { className: 'seller-regist-tip' },
                    _react2.default.createElement(
                        'span',
                        { className: 'regist-tip' },
                        '\u6B64\u9875\u9762\u4EC5\u9650\u4E70\u5BB6\u6CE8\u518C\u3002'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'https://login.aliexpress.com/join/seller/wholesaleJoin.htm' },
                        '\u70B9\u6B64\u6CE8\u518C\u5356\u5BB6\u8D26\u53F7'
                    )
                ) : null,
                this.renderRegisterTips(),
                _react2.default.createElement(
                    'div',
                    { className: 'via-sms-box' },
                    _react2.default.createElement(
                        'a',
                        { className: 'via-sms', style: { display: this.state.isShowViaSMS ? 'inline-block' : 'none' }, onClick: this.showSms },
                        _i18n2.default.REGISTER_SMS
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'via-email-box' },
                    _react2.default.createElement(
                        'a',
                        { className: 'via-email', style: { display: this.state.isShowViaEmail ? 'inline-block' : 'none' }, onClick: this.showEmail },
                        _i18n2.default.REGISTER_EMAIL
                    )
                ),
                this.renderTelphone(),
                this.renderMail(),
                _react2.default.createElement(
                    'div',
                    { className: 'agreement-wrap', style: { display: this.state.isShowAgreement ? 'block' : 'none' } },
                    _react2.default.createElement(
                        'span',
                        null,
                        _i18n2.default.AGREE_MENT
                    ),
                    '\xA0',
                    _react2.default.createElement(
                        'a',
                        { onClick: this.onArgeementClick, href: 'https://rule.alibaba.com/rule/detail/2042.htm' },
                        _i18n2.default.AE_MEMBER_SHIP
                    ),
                    '\xA0',
                    _react2.default.createElement(
                        'span',
                        null,
                        _i18n2.default.AND
                    ),
                    '\xA0',
                    _react2.default.createElement(
                        'a',
                        { onClick: this.onArgeementClick, href: 'https://sale.aliexpress.com/privacy_policy.htm' },
                        _i18n2.default.PRIVACY_POLICY
                    )
                )
            );
        }

        // 设置join数据

    }, {
        key: 'setJoinData',
        value: function setJoinData(joinUiConfig) {
            // 如果后端参数需要送coupon, 在验证前端是否需要送coupon
            if (joinUiConfig && joinUiConfig.sendCouponConfig) {
                (0, _util2.ctrDot)({
                    expPageArea: 'Register_Benifits',
                    expType: 'Benifits'
                });
                this.setState({
                    joinData: joinUiConfig
                });
            }
        }

        // 获取ua和umidtoken

    }, {
        key: 'setUmidToken',
        value: function setUmidToken() {
            var _this4 = this;

            (0, _util.getUmidToken)().then(function () {
                if (window.ctl) {
                    _this4.nCf = window.ctl.noConflict();
                    _this4.nCf.config();
                    // TODO：正确的使用方式必须ready的promise返回之后
                    // 再调用 getUmidToken
                    _this4.nCf.ready();
                }
            });
        }

        // 初始化滑动组件,NoCaptcha已经在初始化的时候通过introduceNoCaptcha引入到全局变量

    }, {
        key: 'initNoCaptcha',
        value: function initNoCaptcha(i18nMap, reBackNc) {
            var self = this;
            if ((0, _util.isMobile)()) {
                window.NoCaptcha.upLang('cn', {
                    SLIDER_LABEL: i18nMap.SLIDE_SUBMIT,
                    CHECK_Y: i18nMap.SLIDE_SUBMIT_TIPS,
                    ERROR_TITLE: '<a href="javascript:__nc.reset()">Refresh</a>',
                    LOADING: i18nMap.LOADING
                });

                this.nc = window.NoCaptcha.init({
                    renderTo: '#' + this.slideBoxId, // 渲染到该DOM ID指定的Div位置
                    appkey: reBackNc.ncAppKey, // 应用标识
                    scene: 'register_h5', // 常见的还有register_h5等
                    token: reBackNc.ncToken,
                    language: 'cn',
                    bannerHidden: false,
                    callback: function callback(data) {
                        // 校验成功回调
                        self.ncData = {};
                        self.ncData.csessionid = data.csessionid;
                        self.ncData.sig = data.sig;
                        self.ncChecked = true;

                        self.setState({
                            showRegisterSlideTip: false
                        });

                        // 滑动组件成功后曝光打点
                        (0, _util2.ctrDot)({
                            expPageArea: 'Register_Verify',
                            expType: 'Verify'
                        });
                        // 滑动组件成功后点击打点
                        (0, _util2.clickDot)({
                            objectType: 'button',
                            buttonType: 'register_verify',
                            objectValue: 'mobile-register_verify'
                        });
                        if (data.csessionid === undefined || data.sig === undefined) {
                            reportArmsError('register_verify', _util2.errorKey.noCsessionidSig);
                        }
                    },
                    error: function error() {
                        // 失败回调,如果连不上服务器或者连续超时，会调此函数
                        // 注册滑动校验失败
                        (0, _util2.clickDot)({
                            buttonType: 'register_verify_fail',
                            objectValue: 'input_box'
                        });
                        reportArmsError('register_verify_fail', _util2.errorKey.initNoCaptchaError);
                    }
                });
                window.NoCaptcha.setEnabled(true);
                self.nc.reset();
            } else {
                self.nc = new window.noCaptcha({ // eslint-disable-line
                    renderTo: '#' + this.slideBoxId, // 渲染到该DOM ID指定的Div位置
                    appkey: reBackNc.ncAppKey, // 应用标识
                    scene: 'register', // 常见的还有register_h5等
                    token: reBackNc.ncToken,
                    language: 'cn',
                    callback: function callback(data) {
                        // 校验成功回调
                        self.ncData = {};
                        self.ncData.csessionid = data.csessionid;
                        self.ncData.sig = data.sig;

                        self.ncChecked = true;

                        self.setState({
                            showRegisterSlideTip: false
                        });

                        // 滑动组件成功后点击打点
                        (0, _util2.ctrDot)({
                            expPageArea: 'Register_Verify',
                            expType: 'Verify'
                        });
                        // 滑动组件成功后点击打点
                        (0, _util2.clickDot)({
                            objectType: 'button',
                            buttonType: 'register_verify',
                            objectValue: 'pc-register_verify'
                        });

                        if (data.csessionid === undefined || data.sig === undefined) {
                            reportArmsError('register_verify', _util2.errorKey.noCsessionidSig);
                        }
                    },
                    error: function error() {
                        // 失败回调,如果连不上服务器或者连续超时，会调此函数
                        // 注册滑动校验失败
                        (0, _util2.clickDot)({
                            buttonType: 'register_verify_fail',
                            objectValue: 'input_box'
                        });
                        reportArmsError('register_verify_fail', _util2.errorKey.initNoCaptchaError);
                    }
                });
                self.nc.upLang('cn', {
                    _startTEXT: i18nMap.SLIDE_SUBMIT,
                    _yesTEXT: i18nMap.SLIDE_SUBMIT_TIPS,
                    _error300: '<a href="javascript:__nc.reset()">Refresh</a>',
                    _errorNetwork: '<a href="javascript:__nc.reset()">Refresh</a>',
                    _Loading: i18nMap.LOADING
                });
                self.nc.reload();
            }
        }

        // 注册成功后获取新人优惠券

    }, {
        key: 'getCoupon',
        value: function getCoupon() {
            var _this5 = this;

            (0, _zoroRequest2.default)({
                url: 'https://login.aliexpress.com/join/getCoupon.htm',
                type: 'get',
                withCredentials: true, // 支持附带详细信息
                data: {
                    registerFrom: this.props.registerFrom,
                    umidToken: this.nCf ? this.nCf.getUmidToken() : '',
                    ua: this.nCf ? this.nCf.getUA() : ''
                }
            }).then(function (data) {
                _this5.props.showCoupon(data);
                _this5.props.toggleMask(false);
            }).catch(function (err) {
                _this5.props.toggleMask(false);
                _zoroArms2.default.error(err);
            });
        }
    }]);
    return Join;
}(_react2.default.Component), _class.propTypes = {
    registerAction: _propTypes2.default.string,
    registerFrom: _propTypes2.default.string,
    couponCode: _propTypes2.default.string,
    sessionId: _propTypes2.default.string,
    toggleMask: _propTypes2.default.func,
    isSendCoupon: _propTypes2.default.bool,
    afterWithCouponJoin: _propTypes2.default.func,
    afterJoin: _propTypes2.default.func,
    afterJoinInit: _propTypes2.default.func,
    mailSignIn: _propTypes2.default.func,
    showCoupon: _propTypes2.default.func,
    batmanNav: _propTypes2.default.func,
    showSNS: _propTypes2.default.func,
    joinUiConfig: _propTypes2.default.object,
    showPhoneRegister: _propTypes2.default.bool,
    isRegisterPhone: _propTypes2.default.bool,
    otherBenefits: _propTypes2.default.object }, _class.defaultProps = {
    registerAction: 'buyerJoin/buyer_xman_register_action', // 注册表单提交路径
    registerFrom: (0, _util.isMobile)() ? 'AE_MSITE_REGISTER' : 'AE_MAIN_POPUP_WHOLESALE', // 后台统计注册来源
    couponCode: '', // couponCode
    sessionId: '', // 可选，sessionId
    isSendCoupon: false, // 是否送coupon

    // 原有events
    afterWithCouponJoin: _util2.noop, // 注册成功并且领取coupon
    afterJoin: _util2.noop, // 注册成功事件
    mailSignIn: _util2.noop, // 用已有邮箱登录事件
    afterJoinInit: _util2.noop, // 初始化成功事件

    // 应该暴露出去的事件
    toggleMask: _util2.noop, // 显示or隐藏遮罩层
    showCoupon: _util2.noop // 显示优惠券信息
}, _temp);


module.exports = Join;

// const g = function (args) {


// };